module.exports = __webpack_public_path__ + "img/skypark-bpb.58987a0b.png";